var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6669 7.70676C16.6669 10.3039 14.5574 12.411 11.9577 12.411C9.36047 12.411 7.25342 10.3039 7.25342 7.70676C7.25342 5.10706 9.36047 3 11.9577 3C14.5574 3 16.6669 5.10706 16.6669 7.70676Z",
    fill: "#79819A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64265 13.7147H16.2758C17.7335 13.7147 18.9184 15.1724 18.9184 16.3573C18.9184 17.8151 17.7361 19 16.2758 19H7.64265C6.18489 19 5 17.5422 5 16.3573C5 14.8996 6.18236 13.7147 7.64265 13.7147Z",
    fill: "#79819A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c026ed74adcc2a8140035392ec791934.svg";
export { ForwardRef as ReactComponent };